import type { TQuestionAnswer } from '$/types/components/questions';

export enum FieldOfStudy {
  ECONOMICS = 5,
  TEACHING_AND_ADMINISTRATIVE_SCIENCE = 1,
  COMPUTER_SCIENCE = 7,
  ENGINEERING = 8,
  SOCIAL_SCIENCE = 14,
}

export enum FieldOfStudyTexts {
  ECONOMICS = 'Wirtschaftswissenschaften',
  TEACHING_AND_ADMINISTRATIVE_SCIENCE = 'Lehramt und Verwaltungswissenschaften',
  COMPUTER_SCIENCE = 'Informatik',
  ENGINEERING = 'Ingenieurwissenschaften',
  SOCIAL_SCIENCE = 'Kultur-, Sprach- und Sozialwissenschaften',
}

const fieldOfStudyList: TQuestionAnswer<FieldOfStudy>[] = [
  {
    id: FieldOfStudy.ECONOMICS,
    value: FieldOfStudyTexts.ECONOMICS,
  },
  {
    id: FieldOfStudy.TEACHING_AND_ADMINISTRATIVE_SCIENCE,
    value: FieldOfStudyTexts.TEACHING_AND_ADMINISTRATIVE_SCIENCE,
  },
  {
    id: FieldOfStudy.COMPUTER_SCIENCE,
    value: FieldOfStudyTexts.COMPUTER_SCIENCE,
  },
  {
    id: FieldOfStudy.ENGINEERING,
    value: FieldOfStudyTexts.ENGINEERING,
  },
  {
    id: FieldOfStudy.SOCIAL_SCIENCE,
    value: FieldOfStudyTexts.SOCIAL_SCIENCE,
  },
];

export default fieldOfStudyList;
